// extracted by mini-css-extract-plugin
module.exports = {"languageMenu":"_bG","languageMenu__link":"_bH","active":"_bI","languageMenu__title":"_bJ","languageMenu__name":"_bK","languageMenu__activeIcon":"_bL"};